export const getLabels = (messages, setNewMessages) => {
  let result = [];
  let prevCreatedAtDate = null;
  messages.forEach(message => {
    if (setNewMessages && !message.seen) {
      result.push({ id: message.id, text: 'new messages' });
      setNewMessages = false;
    }

    const { created_at_date: createdAtDate } = message;
    if (prevCreatedAtDate !== createdAtDate) {
      result.push({ id: message.id, text: createdAtDate });
    }

    prevCreatedAtDate = createdAtDate;
  });
  return result;
};

export const chatNewMessagesStr = count => {
  const cnt = count || 0;
  if (cnt < 10) {
    return cnt;
  }
  return '9+';
};



// WEBPACK FOOTER //
// ./app/javascript/chat/modules/common.js